export function fieldName(field) {
  return field?.name || field?.key || '';
}

export function fieldType(field) {
  return String(field?.type || 'text').toLowerCase();
}

export function isBlank(value) {
  return value === null || typeof value === 'undefined' || value === '' || (Array.isArray(value) && value.length === 0);
}

function normalizeStructuredValue(type, value) {
  if (value && typeof value === 'object' && !Array.isArray(value)) {
    return value;
  }
  const text = String(value || '').trim();
  if (!text) {
    return undefined;
  }
  try {
    const parsed = JSON.parse(text);
    if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
      return parsed;
    }
  } catch (_error) {
    if (type === 'physical_item') {
      return { description: text };
    }
    if (type === 'reference') {
      return { reference: text };
    }
  }
  return { value: text };
}

export function normalizeValuesForSubmit(fields, values, uploadedArtifacts = {}) {
  return (fields || []).reduce((acc, field) => {
    const name = fieldName(field);
    if (!name) {
      return acc;
    }
    const type = fieldType(field);
    const uploadedValue = uploadedArtifacts[name];
    const value = typeof uploadedValue !== 'undefined' ? uploadedValue : values[name];
    if (isBlank(value)) {
      return acc;
    }
    if (type === 'number' || type === 'range') {
      const numberValue = Number(value);
      if (!Number.isNaN(numberValue)) {
        acc[name] = numberValue;
      }
      return acc;
    }
    if (['structured_data', 'physical_item', 'reference', 'key_value_pairs'].includes(type)) {
      const structured = normalizeStructuredValue(type, value);
      if (structured) {
        acc[name] = structured;
      }
      return acc;
    }
    acc[name] = value;
    return acc;
  }, {});
}

export function fileList(value) {
  if (!value) {
    return [];
  }
  return Array.isArray(value) ? value : [value];
}
